import { useWebsiteStore } from '@/stores/website';
import { CommonTypes, LanguageUtil } from '@fibl/oxs-common';

/*
	duplicate version existing only/primarily for related-store
	to avoid a circular dependency chain
	of globalStore -> relatedStore -> global-props -> globalStore
*/

export function booleanDisplay(obj: any) {
	let booleanValue = false;
	if (typeof obj !== 'undefined') {
		booleanValue = obj;
	}
	if (booleanValue) {
		// return i18n.t('admin.crud.yes');
		return 'yes';
	}
	// return i18n.t('admin.crud.no');
	return 'no';
}
export function speciesLocale(obj: CommonTypes.Labels) {
	const store = useWebsiteStore();
	let toCheck = LanguageUtil.getLanguagePriority(store.locale);
	for (let lang of toCheck) {
		let val = getLocaleEntry(obj, lang);
		if (val) return val;
	}
	return '';
}
export function toLocale(obj: any): string {
	const t = typeof obj;
	if (t === 'number') return obj.toString();
	if (t === 'string') return obj;
	if (t === 'boolean') return booleanDisplay(obj);
	if (t === 'object' && obj) {
		if (!Array.isArray(obj)) return JSON.stringify(obj);
		const store = useWebsiteStore();
		let toCheck = LanguageUtil.getLanguagePriority(store.locale);
		for (let lang of toCheck) {
			let val = getLocaleEntry(obj, lang);
			if (val) return val;
		}
		if (obj.length > 0) {
			const enLabel = obj.find((ob) => ob.lang === 'en_GB')?.label;
			if (enLabel) return enLabel;
			return obj[0].label;
		}
	}
	return '';
}
function getLocaleEntry(arr: { lang: string; label: string }[], lang: string): string | null {
	let entry = arr.find((e) => e.lang === lang);
	return entry ? entry.label : null;
}
